// boot 与 SW 共用的消息类型。本文件必须保持零 import，供两个独立构建入口内联。
export const WARM_CODE_CACHE_MESSAGE_TYPE = 'WARM_CODE_CACHE'
export const CACHE_HTML_MESSAGE_TYPE = 'CACHE_HTML'
export const CACHE_HOME_MEDIA_MESSAGE_TYPE = 'CACHE_HOME_MEDIA'
export const EVICT_HOME_MEDIA_MESSAGE_TYPE = 'EVICT_HOME_MEDIA'
export const HOME_MEDIA_REGISTERED_MESSAGE_TYPE = 'HOME_MEDIA_REGISTERED'
export const PREFETCH_HOME_MEDIA_MESSAGE_TYPE = 'IMAGE_PREFETCH'
